// extracted by mini-css-extract-plugin
module.exports = {"loginLink":"ResetPasswordConfirmation_loginLink__5bA9x","illustration":"ResetPasswordConfirmation_illustration__bQM76"};